import { render, staticRenderFns } from "./checklist-task-list-wrap-items.vue?vue&type=template&id=70656fcc&scoped=true"
import script from "./checklist-task-list-wrap-items.vue?vue&type=script&lang=js"
export * from "./checklist-task-list-wrap-items.vue?vue&type=script&lang=js"
import style0 from "./checklist-task-list-wrap-items.vue?vue&type=style&index=0&id=70656fcc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70656fcc",
  null
  
)

export default component.exports